import React from "react";
import { getColumnsData } from "./ReleaseColumns";
import { getReleaseData } from "../../services/Release";
import OTAPagination from "../OTAPagination";

const ReleaseGrid = (props) => {
  const columns = getColumnsData();

  return (
    <OTAPagination
      columns={columns}
      endpointFn={getReleaseData}
      queryName={"releases"}
      filterMode="server"
      getRowId={(row) => row.releaseId}
      exportCSV
      {...props}
      tableTitle={"Available Releases"}
    />
  );
};

export default ReleaseGrid;
